import filter from '@tinkoff/utils/object/filter'
import { Breakpoints, BREAKPOINTS_ORDER, CssStyle } from 'application/theme'
import { camelToKebab } from 'lib/string-case-transforms'
import { StyledProps } from 'styled-components'

export const compileStyles = (styles: CssStyle): string => {
  return Object.entries(styles)
    .map(([rule, value]) => `${camelToKebab(rule)}:${value}`)
    .join(';')
}

export function createMediaStyles<T = any>(fn: (props: StyledProps<T>) => Partial<Breakpoints<any>>) {
  return (props: StyledProps<T>) => {
    const rules = filter(Boolean, fn(props))

    const declaredBreakpoints = BREAKPOINTS_ORDER.filter((breakpoint) => breakpoint in rules)

    return declaredBreakpoints
      .map((breakpointName) => {
        const style = rules[breakpointName]
        return `
          @media ${props.theme.mediaQueries[breakpointName]}{
            ${typeof style === 'object' ? compileStyles(style) : style}
          }
        `
      })
      .join('')
  }
}
